import * as React from 'react'
import { useOutletContext } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import type SurveyForm from 'modules/surveys/store/models/Form'
import type FormAccessGroupMembership from 'modules/surveys/store/models/FormAccessGroupMembership'

interface DeleteModalProps {
  membership: FormAccessGroupMembership
  onClose: () => void
}

const DeleteAuthorAsSupervisorModal = ({ membership, onClose }: DeleteModalProps) => {
  const { form } = useOutletContext<{ form: SurveyForm }>()

  const { running, performAction: onDelete } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      await membership.destroy({ data: { form_id: form.attributes.id } })
      form.fetch()
      closePortal()
    },
    {
      successMessage: i18n.t('surveys.form.managers.delete_modal.supervisor_deleted'),
    }
  )

  return (
    <Modal
      illustration="alert"
      title={i18n.t('surveys.form.managers.delete_modal.title')}
      description={i18n.t('surveys.form.managers.delete_modal.description')}
      onClose={onClose}
      onSubmit={onDelete}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running} submit>
            {i18n.t('common.continue')}
          </Button>
        </>
      }
    />
  )
}

export default observer(DeleteAuthorAsSupervisorModal)
